import React, { useState } from 'react';
import CopyableField from './CopyableField';
import NoteDisplay from './NoteDisplay';
import { formatCardNumber, maskCardNumber } from '../utils/cardNumber';

const BankCard = ({ card, onEdit, onDelete }) => {
  const [numberVisible, setNumberVisible] = useState(false);
  const [cvvVisible, setCvvVisible] = useState(false);

  const cardNumber = card.card_number || '';
  const formattedNumber = formatCardNumber(cardNumber);
  const maskedNumber = maskCardNumber(cardNumber);
  const maskedCvv = '•'.repeat(Math.max(card.cvv?.length || 0, 3));

  return (
    <article className="w-full min-w-0 bg-white border border-gray-300 rounded-lg p-3 flex flex-col gap-2">
      <header className="flex items-center justify-between gap-2">
        <h2 className="font-bold text-gray-900 text-md leading-tight truncate min-w-0 flex-1">
          {card.title}
        </h2>
        <div className="flex items-center gap-2 shrink-0">
          <button
            type="button"
            className="inline-flex items-center justify-center border border-gray-300 rounded bg-white text-gray-700 hover:bg-gray-50 h-7 w-7 text-xs"
            onClick={() => onEdit(card)}
            title="Edit"
            aria-label="Edit"
          >
            <i className="fa-solid fa-pen" />
          </button>
          <button
            type="button"
            className="inline-flex items-center justify-center border border-gray-300 rounded bg-white text-gray-700 hover:bg-gray-50 h-7 w-7 text-xs"
            onClick={() => onDelete(card)}
            title="Delete"
            aria-label="Delete"
          >
            <i className="fa-solid fa-trash" />
          </button>
        </div>
      </header>

      <CopyableField
        value={card.cardholder_name}
        decorIcon="fa-regular fa-user"
      />

      <CopyableField
        value={cardNumber}
        displayValue={numberVisible ? formattedNumber : maskedNumber}
        decorIcon="fa-solid fa-hashtag"
        actionButtons={[
          {
            icon: numberVisible ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye',
            onClick: () => setNumberVisible((prev) => !prev),
            title: numberVisible ? 'Hide card number' : 'Show card number',
          },
        ]}
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <CopyableField
          value={card.expiry_date}
          decorIcon="fa-regular fa-calendar"
        />
        <CopyableField
          value={card.cvv}
          displayValue={cvvVisible ? card.cvv : maskedCvv}
          decorIcon="fa-solid fa-key"
          actionButtons={[
            {
              icon: cvvVisible ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye',
              onClick: () => setCvvVisible((prev) => !prev),
              title: cvvVisible ? 'Hide CVV' : 'Show CVV',
            },
          ]}
        />
      </div>

      <NoteDisplay value={card.note} />
    </article>
  );
};

export default BankCard;
